module.exports = __webpack_public_path__ + "img/smw-library08.653b5c73.jpg";